import { CSSProperties } from "@material-ui/core/styles/withStyles";
import CancelIcon from '@material-ui/icons/Cancel';
import React from "react";

interface UnavailableIconProps {
    isVisible?: boolean;
    styles?: CSSProperties | null;
}

const UnavailableIcon: React.FC<UnavailableIconProps> = (props) => {
    return (
        props.isVisible ? <CancelIcon style={{
            cursor: 'not-allowed',
            color: 'grey',
            ...props.styles
        }} /> : null
    );
}
export default UnavailableIcon;